/** @jsx h */
import FilterFieldsetOverlay from './FilterFieldsetOverlay';
import { Fragment } from 'preact';

const FilterContainer = ({
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  pluginNamespace,
  isReset,
}) => {
  return (
    <Fragment>
      <div className="search-form__filters">
        <p>Filtern nach</p>
        <ul className="search-form__list">
          {facets.map((facet, index) => (
            <FilterFieldsetOverlay
              id={index}
              key={facet.label}
              title={facet.label}
              facet={facet}
              optionsActiveCount={
                facetsActive?.selected.filter(
                  option => option.name === facet.name
                ).length
              }
              triggerAjaxSubmit={triggerAjaxSubmit}
              pluginNamespace={pluginNamespace}
              isReset={isReset}
            />
          ))}
        </ul>
      </div>
    </Fragment>
  );
};

export default FilterContainer;
